const ROW_ACTION_CLASS =
  'h-auto gap-[5px] p-0 text-xs font-semibold leading-4 [&_svg]:size-[15px]';

export {ROW_ACTION_CLASS};

const EXPLAINER_LIST =
  'text-[var(--chekin-text-secondary)] [&_strong]:font-semibold [&_strong]:text-[var(--chekin-color-brand-navy)]';

export {EXPLAINER_LIST};
